import { useEffect, type ReactNode } from 'react';
import { Box, Button } from '@stitch-fix/mode-react';
import { OnboardingNav } from './OnboardingNav';
import { type OnboardingStep } from './steps/steps';
import { isAndroidApp } from '../../../utils/android/android';
const getButtonText = (currentStep: OnboardingStep): string => {
  if (currentStep === 'welcome') {
    return 'Get started';
  }
  if (currentStep === 'selfie') {
    return 'Submit';
  }
  return 'Next';
};
interface OnboardingProps {
  children: ReactNode;
  currentStep: OnboardingStep;
  onNext: () => void;
  onBack: () => void;
  disabled?: boolean;
  hideFooter?: boolean;
}
export const OnboardingFlow = ({
  children,
  currentStep,
  onNext,
  onBack,
  disabled = false,
  hideFooter = false
}: OnboardingProps) => {
  useEffect(() => {
    // Scroll to top when step changes
    window.scrollTo(0, 0);
  }, [currentStep]);
  return <Box width="100%" style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '100vh'
  }} bgColor={isAndroidApp() ? 'white' : 'gray-99'}>
      <Box bgColor="white" maxWidth="600px" style={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '95vh',
      width: '100%'
    }}>
        {(!isAndroidApp() || currentStep !== 'welcome') && <OnboardingNav showBackButton showCloseButton={isAndroidApp()} onBackClick={onBack} />}
        <Box px={currentStep === 'welcome' ? 0 : 1.5} style={{
        flex: '1 1 auto',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto'
      }}>
          <main style={{
          flex: '1 1 auto',
          display: 'flex',
          flexDirection: 'column'
        }}>
            {children}
          </main>
        </Box>
        {currentStep !== 'welcome' && !hideFooter && <Box bgColor="white" py={3} mx="auto" width="100%" px={{
        sm: 1.5,
        md: 2
      }} maxWidth="400px">
            <Button onClick={onNext} width="fill" disabled={disabled} mb={3}>
              {getButtonText(currentStep)}
            </Button>
          </Box>}
      </Box>
    </Box>;
};